module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9n7r4r-102a249d0969fbd952be55dc6b05b837.svg";